import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { useCartStore } from "../stores/cartStore";

export function AddToCartModal({ isOpen, onClose, product }) {
    const items = useCartStore((state) => state.items);
    const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
            <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full text-center animate-slide-in-up">
                <h2 className="text-lg font-semibold text-stone-900 mb-2">
                    {product.name} added to cart 🎉
                </h2>
                <p className="text-sm text-stone-600 mb-4">What would you like to do next?</p>
                <div className="flex flex-col gap-3">
                    <Link to="/cart">
                        <Button className="w-full bg-emerald-900 hover:bg-emerald-800">
                            View Cart {totalItems > 0 && `(${totalItems})`}
                        </Button>
                    </Link>
                    <Button
                        variant="ghost"
                        className="w-full text-stone-800"
                        onClick={onClose}
                    >
                        Continue Shopping
                    </Button>
                </div>
            </div>
        </div>
    );
}
